<template>
  <div class="product-modal">
    <div class="overlay" @click="$emit('closeProductModal')"></div>
    <div class="wrapper">
      <img
        class="close"
        @click="$emit('closeProductModal')"
        src="./../img/cross.svg"
      />
      <div class="container">
        <transition name="fade">
          <div class="product-preview" v-if="productView">
            <div class="preview-container">
              <div class="preview-wrapper">
                <div class="preview">
                  <transition name="fade">
                    <span
                      class="title"
                      v-if="$parent.addToCartChosenItem == productView.id"
                    >
                      <b>ADDED</b></span
                    >
                  </transition>
                  <img
                    :src="$parent.imgDomain + productView.img_url"
                    class="img"
                  />
                </div>
                <div class="text">
                  <div class="row">
                    <div class="desc">{{ productView.type }}</div>
                  </div>
                  <div class="title">{{ productView.title }}</div>
                  <div class="row">
                    <div class="title price">
                      <PriceFormatter
                        :price="displayPrice(productView)"
                        rootClass="product-modal-price"
                        currencyClass="product-modal-price__currency"
                        textClass="product-modal-price__text"
                        amountClass="product-modal-price__amount"
                      />
                      <PriceFormatter
                        v-if="displayOldPrice(productView)"
                        :price="displayOldPrice(productView)"
                        rootClass="product-modal-price-old"
                        currencyClass="product-modal-price-old__currency"
                        textClass="product-modal-price-old__text"
                        amountClass="product-modal-price-old__amount"
                      />
                    </div>
                  </div>
                  <button
                    class="button"
                    @click="$parent.addToCart(productView, productView.id)"
                  >
                    <span>Add to cart</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <div class="section arrivals-section recommended-section">
          <div class="wrapper">
            <div class="top">
              <div class="title">
                <b>Similar product</b>
              </div>
            </div>
            <SlickItem
              v-if="similarProducts.length"
              :list="similarProducts"
              :addToCartChosenItem="addToCartChosenItem"
              @addToCart="addToCart"
              @goToProduct="goToProduct"
              :currency="currency"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SlickItem from "../components/SlickItem.vue";
import PriceFormatter from "./PriceFormatter.vue";
export default {
  name: "ProductPage",
  props: ["addToCartChosenItem", "productView", "similarProducts"],
  components: {
    SlickItem,
    PriceFormatter,
  },
  data: function () {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    displayPrice(item) {
      return item.internal_price || item.price;
    },
    displayOldPrice(item) {
      const price = parseFloat(this.displayPrice(item));
      const oldPrice = item.internal_old_price || item.old_price;
      const numericOldPrice = parseFloat(oldPrice);

      if (
        !oldPrice ||
        Number.isNaN(numericOldPrice) ||
        numericOldPrice <= 0 ||
        (!Number.isNaN(price) && numericOldPrice <= price)
      ) {
        return null;
      }

      return oldPrice;
    },
    addToCart(item, id) {
      this.$parent.addToCart(item, id);
    },
    goToProduct(item) {
      this.$parent.goToProduct(item);
    },
  },
  computed: {
    currency() {
      return this.$store.getters["app/currency"];
    },
  },
};
</script>

<style scoped>
.product-modal-price {
  color: #1e2329;
  font-family: "Open Sans", sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 38px;
}

.product-modal-price ::v-deep .product-modal-price__currency,
.product-modal-price ::v-deep .product-modal-price__text,
.product-modal-price ::v-deep .product-modal-price__amount {
  color: #1e2329;
}

.product-modal-price-old {
  color: #808a93;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  margin-left: 10px;
  position: relative;
}

.product-modal-price-old::after {
  content: "";
  width: 100%;
  height: 2px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: #808a93;
}

.product-modal-price-old ::v-deep .product-modal-price-old__currency,
.product-modal-price-old ::v-deep .product-modal-price-old__text,
.product-modal-price-old ::v-deep .product-modal-price-old__amount {
  color: #808a93;
}
</style>
